import { Flow } from 'signup-constants/Flow';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getExperiment } from '../../experiments/Experiments';
import { experimentsEnabled } from '../../experiments/experimentsEnabled';
import { EndpointKey } from '../../http/EndpointKey';
import { isFlow } from '../../utils/isFlow';
import { getExperimentFromState } from '../experiments/selectors';
import { hasEndpointBeenFetched } from '../http-responses/selectors';
import { Intent } from 'signup-constants/Intent';
import { isIntent } from '../../utils/isIntent';
import { getQueryParam } from '../../routing/getQueryParam';
import { getAppKeyValue, getCountryCode } from '../app/selectors';
import { AppKey } from '../../app/AppKey';
export const getPurchaseState = state => {
  return state.purchase;
};
export const getIsMonthlySingleProduct = state => {
  return getPurchaseState(state).isMonthlySingleProduct;
};
export const getAcq151ActiveAndIsUsdPurchaseFlow = state => {
  if (!experimentsEnabled()) return false;
  const experiment = getExperimentFromState(state, ExperimentKeys.ACQ0151);
  const experimentObject = getExperiment(ExperimentKeys.ACQ0151);
  if (!experiment || !experimentObject) return false;
  const isEnrolledFlow = isFlow([Flow.Purchase]);
  const isIntentPurchase = isIntent(Intent.purchase);
  const hasDtbId = !!getQueryParam('dtbId');
  const isCurrentUSD = getQueryParam('currency') === 'USD';
  return isEnrolledFlow && isIntentPurchase && hasDtbId && isCurrentUSD;
};
export const waitForCountryCode = state => {
  const errorGettingCountryCode = getAppKeyValue(AppKey.ErrorGettingCountryCode)(state) || false;
  return getCountryCode(state) !== null || errorGettingCountryCode;
};
export const getIsPurchaseFlowReady = state => {
  const shouldCallAcq151 = getAcq151ActiveAndIsUsdPurchaseFlow(state);
  return !shouldCallAcq151 || shouldCallAcq151 && hasEndpointBeenFetched(state, EndpointKey.PurchaseProductInfo) && waitForCountryCode(state);
};
export const getProductShortName = state => {
  const name = state.purchase.productInfo.productDisplayName || '';
  return name.split('(')[0].trim();
};